var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#fff",
    stroke: "#2355FC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 23.233v1.957a1.304 1.304 0 01-1.425 1.305 12.95 12.95 0 01-5.641-2.003 12.733 12.733 0 01-3.922-3.914 12.894 12.894 0 01-2.007-5.656 1.304 1.304 0 011.301-1.422h1.961a1.308 1.308 0 011.307 1.122c.083.626.236 1.241.458 1.833a1.303 1.303 0 01-.294 1.377l-.83.828a10.447 10.447 0 003.921 3.914l.83-.828a1.307 1.307 0 011.38-.294c.593.221 1.209.374 1.836.457a1.308 1.308 0 011.125 1.324z",
    fill: "#2355FC"
  })));
}

export default SvgCallCircle;